import getWithToken from './base/get-with-token'

const queryCustomerSiteContact = id => getWithToken(`/customer/${id}/contact`)

export default queryCustomerSiteContact